<template>
  <router-link :to="{ name: 'TVShowMain', params: { slug: string_to_slug(network.name), id:network.id, name:network.name }}" class="city-card" @click.native="onSelect()">
    <img :src="'http://image.tmdb.org/t/p/w185/' + network.poster_path" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ network.title }}</div>
      <div class="city-card__subtitle">See all episodes</div>
      <div class="city-card__number">{{ network.dorms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'TVShowMain', params: { slug: string_to_slug(network.name), id:network.id, name:network.name  }}"
        title="Inspect Episodes"
      />
    </div>
  </router-link>
</template>

<script>
import Utility from '../../common'
export default {
  name: 'NetworkCard',
  props: {
    network: Object
  },
  methods: {
    onSelect() {
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', this.network.name)
      window.localStorage.setItem('genre', this.network.id)
    },
        string_to_slug (str) {
          return Utility.string_to_slug (str)
    },    
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/city-card";
</style>
